export const getCaptchaKey = (): string => process.env.REACT_APP_CAPTCHA_SITE_KEY ?? '';
